import { createApp } from 'vue'
import App from './App.vue'
import './style/font.scss'

createApp(App).mount('#app')
